export const hasPermission = (userPermissions: string[] = [], requiredPermissions: string[] = []): boolean => {
  if (requiredPermissions.length === 0) {
    return true;
  }

  return requiredPermissions.every((permission) => userPermissions.includes(permission));
};
